import { FacilityForAdminDto } from './facility-for-admin.dto';
import { AdminNoteDto } from '../common/admin-note.dto';

export interface FacilityAdminDetailDto extends FacilityForAdminDto {
  bedCount: number;
  specialties: string[];
  notes: AdminNoteDto[];
  averageContractorRating: number;
  totalShiftsPosted: number;
  totalAmountPaid: number;
  lastPaymentDate?: string | null; // DateTime as ISO string
}
